/*********************** Custom JS for Boost AI Search & Discovery  ************************/

console.log("qwerty-start");
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
 (componentRegistry) => {
  console.log("qwerty-start-now");
  componentRegistry.useComponentPlugin('ProductLabel', {
   name: 'Modify Product Label',
   enabled: true,
   apply: () => ({
    className: 'extra-class',
    props: (props) => {
     props.label += ' Boost';
     return props;
    },
    style: {
     color: 'red',
    },
    render(elementModel, currentRenderElement) {
      console.log(currentRenderElement);
     return currentRenderElement;
    },
    beforeRender(element) {
      console.log("qwerty-before");
    },
    afterRender(element) {
      console.log("qwerty-after");
    },
   }),
  });
 }
]);
console.log("qwerty-end");

// ProductCollageItem.prototype.compileTemplate = function(){}
// ProductList.prototype.afterRender = function(){console.log("teeest")};
// if (window.boostSDAppConfig) {  window.boostSDAppConfig.integration =  Object.assign({ labels: 'flair' }, window.boostSDAppConfig.integration || {});}






